import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {
    public dashboardEditable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public imageSource: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
}